const CURRENT_CHAR_COUNT_SELECTOR = '[data-current-char-count]'
const CHAR_COUNT_LIMIT_SELECTOR = '[data-char-count-limit]'

class CharCounter extends HTMLElement {
    constructor() {
        super()
        this.currentCharCountEl = this.query(CURRENT_CHAR_COUNT_SELECTOR)
        this.charCountLimitEl = this.query(CHAR_COUNT_LIMIT_SELECTOR)
        this.targetSelector = this.dataset.target
        this.target = document.querySelector(this.targetSelector)
        this.handleErrors()
        this.bindEvents()
    }

    bindEvents() {
        this.target.addEventListener('keyup', this.updateCharCount.bind(this))
    }

    updateCharCount() {
        this.currentCharCountEl.textContent = this.target.value.length
        this.charCountLimitEl.textContent = this.target.maxLength
        if (this.target.value.length >= this.target.maxLength) {
            this.classList.add('color-blood-orange')
        } else {
            this.classList.remove('color-blood-orange')
        }
    }

    handleErrors() {
        if (!this.query(CURRENT_CHAR_COUNT_SELECTOR)) {
            throw new Error(`Missing ${CURRENT_CHAR_COUNT_SELECTOR} element`)
        }
        if (!this.query(CHAR_COUNT_LIMIT_SELECTOR)) {
            throw new Error(`Missing ${CHAR_COUNT_LIMIT_SELECTOR} element`)
        }

        if (!this.targetSelector) {
            throw new Error('Missing target selector')
        }

        if (!this.target) {
            throw new Error(`Missing target element for selector ${this.targetSelector}`)
        }

        if (!this.target.tagName.toLowerCase() === 'textarea' || !this.target.tagName.toLowerCase() === 'input') {
            throw new Error(`Target element must be an input element`)
        }
    }

    query(selector) {
        return this.querySelector(selector)
    }
}

customElements.define('char-counter', CharCounter)

const emailInputWithError = document.querySelector('[aria-describedby="ContactForm-email-error"]')

const removeErrorMessage = () => {
    if (emailInputWithError.value.length > 0) {
        emailInputWithError.removeAttribute('aria-invalid')
        const errorMessage = document.querySelector('#ContactForm-email-error')
        const errorIcon = document.querySelector('[data-error-icon]')
        if (errorMessage) {
            errorMessage.remove()
        }
        if (errorIcon) {
            errorIcon.remove()
        }
        emailInputWithError.removeEventListener('keyup', removeErrorMessage)
    }
}

emailInputWithError.addEventListener('keyup', removeErrorMessage)  